import { store } from "src/app/store";
import { orderApi } from "src/api/services/ordersApi";
import { authLoader } from "./authLoader";

export const getOrdersLoaders = async () => {
  return authLoader(() =>
    store.dispatch(orderApi.endpoints.getOrders.initiate({ page: "care" })),
  );
};
